import BlockList from "./BlockList";
import useBlockManager from "../../hook/useBlockManager";
import { useTreeStateContext } from "../../contexts/TreeContext";
import { useCameraStateContext } from "../../contexts/CameraContext";
import { useEffect, useRef } from "react";
import useBlock from "/src/features/editor/hook/block/useBlock";
import Category from "../Category/Category";
import useCategorySelection from "../../hook/category/useCategorySelection";
import useBlockMenu from "../../hook/block/useBlockMenu";
// Component For listing all the blocks visible
function BlockContainer() {

    const { blocksVisible, categories } = useTreeStateContext();

    const { onClickDuplicate :duplicateBlock ,onClickDelete : deleteBlock } = useBlockMenu();


    useBlockManager();
    useCategorySelection()

    const { panzone } = useCameraStateContext()
    const hoveredElementRef = useRef(null);

    var scale = 1;
    if (panzone) {
        scale = panzone.getTransform().scale;
    }
    
    const handleKeyDown = (e) => {
        let method = ""
        let params = []
        if ((e.ctrlKey || e.metaKey) && e.key === 'd') { // CTRL-D - DUPLICATE
            method = duplicateBlock;
            params = (block) => [block.id];
        }
        else if (e.key == "Delete") {
            method = deleteBlock
            params = (block) => [block?.classList.toString().split(" ")[1],true, block.id];
        }

        if (method == "") {
            return;
        }
        let block = getBlockHovered()
        if (!block || block.classList.contains("scenario")) {
            return;
        }
        method( ...params(block));
        e.preventDefault(); // pour ne pas avoir l'ajout de favori ou autre chose bizarre...

    }

    const getBlockHovered = () => {
        let elements = Array.from(document.querySelectorAll(":hover"));
        let blockHovered = elements.filter(element => element.classList.contains("block") && element.id.includes("_"));
        if (blockHovered.length == 0 || blockHovered.length > 1) {
            return null
        }

        return blockHovered[0]
    }
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);

        };
    }, [blocksVisible]);

    const handleMouseEnter = (e) => {
        hoveredElementRef.current = e.target;
    };

    const handleMouseLeave = () => {
        hoveredElementRef.current = null;
    };

    return (
        <div className="blocks_container">
            {blocksVisible && blocksVisible.map((block, i) => {
                const Block = BlockList[block.type.name];
                return <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} key={i}>
                    <Block key={block.object_id} {...block} lowVersion={scale < 0.3} /> </div>
            })}
            {categories && categories.map((category, i) => {
                return <Category informations={category} key={i} ></Category>

            })}
        </div>
    )
}

export default BlockContainer;